<template>
    <div class="search-territories">
        <v-autocomplete
            v-if="!select || select.type != 'code'"
            v-model="select"
            :items="items.length ? items : this.territories"
            :search-input.sync="search"
            class="search-territories-combo"
            dark
            label="Département"
            solo-inverted
            flat
            hide-selected
            hide-details
            append-icon="mdi-chevron-down"
            item-text="code"
            item-value="code"
            return-object
            :no-filter="true"
            no-data-text=""
            :multiple="false"
            :clearable="true"
        >
            <template slot="selection" slot-scope="data">
                <div class="suggest selected" v-if="data.item">
                    <typo name="body-10-normal" class="code">{{ data.item.code }} </typo>
                    <typo name="body-14-medium">{{ data.item.label }}</typo>
                </div>
            </template>
            <template slot="item" slot-scope="data">
                <div class="suggest">
                    <typo name="body-10-normal" class="code">{{ data.item.code }}</typo>
                    <typo name="body-14-light" v-html="highlight(data.item.label)" />
                </div>
            </template>
        </v-autocomplete>
    </div>
</template>

<script>
import { Services } from "src/services/Services";
import { filter, trim } from "lodash";
import { highlight } from "src/utils/highlight";

export default {
    props: ["value"],
    data() {
        return {
            select: null,
            search: null,
            items: [],
        };
    },
    mounted() {
        this.select = this.value;
    },
    methods: {
        highlight(string) {
            return trim(highlight(string, this.search));
        },
        clean(string) {
            if (string) return string.replace(/[-_ ]/, "").toLowerCase();
            return string;
        },
    },
    watch: {
        value() {
            this.select = this.value;
        },
        search() {
            const items = filter(this.territories, t => {
                return (
                    t.code.indexOf(this.search) > -1 ||
                    this.clean(t.label).indexOf(this.clean(this.search)) > -1
                );
            });
            this.items = items;
        },
        select() {
            this.search = "";
            if (this.select) {
                this.$emit("input", this.select);
            } else {
                this.$emit("input", "");
            }
        },
    },
    asyncComputed: {
        async territories() {
            const territories = await Services.api.ca.getAllTerritories();
            return filter(territories, t => t.code != "all" && t.code != "met");
        },
    },
};
</script>

<style lang="sass">

.search-territories
    width: 270px
    +r(480)
        max-width: 100%
        width: 100%

.search-territories-combo
    &.v-text-field--solo
        border-radius: 0

    &.theme--dark.v-text-field--solo-inverted.v-input--is-focused > .v-input__control >.v-input__slot,
    &.theme--dark.v-text-field--solo-inverted > .v-input__control > .v-input__slot
        background: $color-secondary
        border: 1px solid white

    .theme--dark.v-label
        color: white !important

    .theme--dark.v-icon
        color: white !important

    &.theme--dark.v-input input
        caret-color: white
        color: white !important

.suggest
    display: flex
    flex-direction: row
    .code
        background: black
        margin-right: 10px
        padding: 0 5px
        text-align: center
        color: white
        display: inline-block
        text-transform: uppercase
        min-width: 30px
        line-height: 10px
        display: flex
        align-items: center
        align-content: center
        justify-content: center

.suggest.selected
    white-space: nowrap

    .typo
        color: white

    .code
        background: white
        color: $color-secondary
        padding: 0 3px
        width: auto

    .highlight
        background: transparentize($color-main, 0.8)
</style>
